export type TKeyEventGroup = 'escape' | 'tab' | 'x-arrows' | 'y-arrows';

export const enum FocusTrapAttr {
  ROOT = 'data-focus-trap-root',
  DISABLE = 'data-focus-trap-disable',
}
